import { createSelector } from '@ngrx/store';
import { getLocationDetails } from '../../../locations/selectors';

export const getVirtualLocationsForPhysicalLocation = (locationNo: number) => createSelector(
    getLocationDetails(locationNo), (locationDetails) => locationDetails?.VirtualLocations
);
